import React from "react";
import { withRouter } from "react-router-dom";
import { STUDENT, IS_SESSION_ACTIVE } from "../../utils/url-builder";
import { setTokenOnLogin } from "../../utils/api-authentication";
import {
  setInstituteKneuraId,
  setInstituteId,
  setToken,
  setKneuraId,
  setUserId,
  setusername,
  setClassInfo,
  getToken,
  setNotificationToken,
  setUserRole,
  deleteAll,
  setClassRequestInfo
} from "../../utils/authentication-access";
import Snackbar from "@material-ui/core/Snackbar";
import BaseService from "../../store/services/base.service";
import queryString from "query-string";
import CircularIndeterminate from "../../UI/CustomLoader/CustomCircularProgressBar";
import classes from "./loginFromWebsite.module.css";
import { Mixpanel } from "../../utils/mixpanel";
import { withTranslation } from "react-i18next";
import { WEBSITE_URL } from "../../config";
import studentsService from "../../store/services/students.service";

class LoginFromWeb extends React.Component {
  constructor(props) {
    super(props);
    LoginFromWeb.context = this;
    this.state = {
      errmsg: " ",
      openerrmsg: false
    };
  }

  async componentDidMount() {
    // this.validateUserToken();
    deleteAll();
    const values = queryString.parse(this.props.location.search);
    let {
      kneuraId,
      userId,
      instituteKneuraId,
      instituteId,
      access_token,
      userName,
      notificationToken,
      userRoles
    } = values;

    if (
      !kneuraId ||
      !userId ||
      // !instituteKneuraId ||
      // !instituteId ||
      !access_token ||
      !userRoles
    ) {
      // this.props.history.replace("/login");
      window.location.replace(WEBSITE_URL);
    } else {
      let self = this;
      sessionStorage.clear();
      setKneuraId(kneuraId);
      setUserId(userId);
      setInstituteKneuraId(instituteKneuraId);
      setInstituteId(instituteId);
      setToken(access_token);
      setTokenOnLogin(access_token);
      setusername(userName);
      setNotificationToken(notificationToken);
      setUserRole(userRoles);
      Mixpanel.identify(kneuraId);
      Mixpanel.track("Successful Login");
      Promise.all([
        this.getAllClasses(kneuraId, instituteKneuraId),
        this.getAllClassRequests()
      ]).then(() => {
        this.props.history.push("/dashboard");
      })
    }
  }

  validateUserToken() {
    return new Promise(async (resolve, reject) => {
      try {
        const url = IS_SESSION_ACTIVE.isSessionActive();
        let res = await new BaseService().makeGetRequestGeneric(url);
        this.props.history.replace("/dashboard");

        return resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  getAllClasses = async (user_id, Inst_id) => {
    const url = STUDENT.getStudentClass();

    let res = await new BaseService().makeGetRequestGeneric(url, {
      access_token: getToken(),
      "Content-Type": "application/json",
      role: "learner",
      user_kneura_id: user_id,
      institute_kneura_id: Inst_id
    });
    if (res.data.length > 0) {
      setClassInfo(res.data[0]);
    }
    // this.props.history.push("/dashboard");
  };

  getAllClassRequests = async () => {
    let {classRequests} = await studentsService.getClassRequests()
    localStorage.setItem("classRequestsData", JSON.stringify(classRequests));
    if (classRequests.length > 0) {
      setClassRequestInfo(classRequests[0]);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={classes.topDiv}>
          <CircularIndeterminate color="secondary" />
          <div className={classes.loaderTextDiv}>{t("Loading ...")}</div>
        </div>
        <Snackbar
          message={this.state.errmsg}
          open={this.state.openerrmsg}
          onClose={() => this.setState({ openerrmsg: false })}
          autoHideDuration={2000}
        />
      </div>
    );
  }
}

export default withRouter(withTranslation()(LoginFromWeb));
